import { RichText } from '@marriott/mi-ui-library';
import { MTimer } from '@marriott/mi-web-ui-kit';
import { PROMOTIONS_CONSTANT } from '../../../modules/utils/constants/constants';
import { PromotionBannerProps } from '../PromotionBanner.types';
import { StyledPromotionBannerTimer } from './PromotionBannerTimer.styles';
import { getPromotionEdtEndOfDay } from '../../../modules/utils/promotionHelper';

export const PromotionBannerTimer = (props: PromotionBannerProps) => {
  const title =
    props?.promotionDetails?.loyaltyPromotion?.descriptions?.name ||
    props?.promotionDetails?.promotion?.descriptions?.name;
  const description =
    (
      props?.promotionDetails?.loyaltyPromotion?.offers?.[0]?.descriptions?.descriptions ||
      props?.promotionDetails?.promotion?.offers?.[0]?.descriptions?.descriptions
    )
      ?.find(d => d.key === 'short')
      ?.value?.replace(PROMOTIONS_CONSTANT.HTML_TAG_REGEX, '') || '';
  const targetDate =
    props?.promotionDetails?.loyaltyPromotion?.offers?.[0]?.hurdle?.endDate ||
    props?.promotionDetails?.promotion?.offers?.[0]?.endDate;

  return (
    <StyledPromotionBannerTimer className="py-5 fullbleed m-container-fullbleed">
      <div className="container py-5 d-lg-flex justify-content-between align-items-center">
        <div>
          <div className="t-title-s">{title}</div>
          <RichText text={description} componentId="notes" customClass="notesRte mt-3 t-" />
        </div>
        <div className="timer-container pl-lg-5 mt-5 mt-lg-0">
          <MTimer
            className="promotions-timer"
            targetDate={getPromotionEdtEndOfDay(targetDate)?.toISOString()}
            customSeparatorClass="m-price-xl mt-2 timer-separator"
            daysLabel={props?.timerDays}
            hoursLabel={props?.timerHours}
            minutesLabel={props?.timerMinutes}
            secondsLabel={props?.timerSeconds}
            customDigitClass="t-title-s promo-timer"
          />
        </div>
      </div>
    </StyledPromotionBannerTimer>
  );
};
